module.exports = __webpack_public_path__ + "img/217.wall_painting.e1e3375e.svg";